import { useCallback, useEffect, useState } from "react";
import ModalContainer from "./ModalContainer";
import React from "react";

type File = {
  name: string;
  type: string;
  url: string;
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  file: File;
}

const ViewFileModal = ({ isOpen, onClose, file }: Props) => {
  const [fileType, setFileType] = useState("");

  const getFileType = useCallback(() => {
    switch (file.type) {
      case "png":
      case "jpg":
      case "jpeg":
      case "gif":
      case "heif":
      case "webp":
        setFileType("image");
        break;
      case "mp4":
        setFileType("video");
        break;
      case "pdf":
        setFileType("pdf");
        break;
      case "txt":
        setFileType("text");
        break;
      default:
        setFileType("image");
        break;
    }
  }, [file]);

  useEffect(() => {
    getFileType();
  }, [getFileType]);

  return (
    <ModalContainer
      isCentered
      size="6xl"
      isOpen={isOpen}
      onClose={onClose}
      closeBtnColor="black"
      closeBtnBgColor="whiteAlpha.500"
      closeOnOverlayClick={false}
      contentProps={{
        width: "800px",
        h: "fit",
        p: "4px",
        mt: "47px",
        mb: "2px",
        overflowY: "auto",
        bg: "transparent",
      }}
    >
      <div className="fixed top-0 left-0 w-screen h-[45px] box-border lg:px-[50px] bg-black bg-opacity-60 flex items-center gap-[10px]">
        <p className="text-white text-[16px] font-medium">{file?.name}</p>
      </div>
      <div className="w-full h-full flex items-center justify-center">
        {fileType === "video" && (
          <video
            src={file.url}
            controls
            className="w-fit max-h-[95vh] lg:max-h-[85vh]"
          />
        )}
        {fileType === "image" && (
          <img
            src={file.url}
            alt={file?.name}
            className="w-fit max-h-[95vh] lg:max-h-[85vh]"
          />
        )}
        {fileType === "pdf" && (
          <iframe
            className="w-fit max-h-[95vh] lg:max-h-[85vh]"
            src={file.url}
            title={file.name}
          />
        )}
        {fileType === "text" && (
          <iframe
            className="w-fit max-h-[95vh] lg:max-h-[85vh]"
            src={file.url}
            title={file.name}
          />
        )}
      </div>
    </ModalContainer>
  );
};

export default ViewFileModal;
